/**
 * Action type to INIT_DEVICE.
 */
export const INIT_DEVICE = 'INIT_DEVICE';
/**
 * Action type to CLOSE_HID_DEVICE.
 */
export const CLOSE_HID_DEVICE = 'CLOSE_HID_DEVICE';
/**
 * Action type to REQUEST_HID_DEVICE.
 */
export const REQUEST_HID_DEVICE = 'REQUEST_HID_DEVICE';
/**
 * Action type to UPDATE_DEVICE.
 */
export const UPDATE_DEVICE = 'UPDATE_DEVICE';
